export const getApplicationFieldsList = async function (param) {
    const requestURL = "/applicationFields/web/list";
    const requestParam = param;

    const response = await o2.util.Http.requestData(requestURL, requestParam, {parameterType: "json"});

    return response;
};

export const getApplicationFields = async function (appfldId) {
    const requestURL = `/applicationFields/${appfldId}`;
    const requestParam = {};

    const response = await o2.util.Http.requestData(requestURL, requestParam, {method: "GET"});

    return response;
};
